import type { IncidentHistoryEntryResponse } from '@prerender/diagnostics-api';
import { useId, useState } from 'react';

import {
  domainCountLabel,
  historyChangeHeadLabel,
  historyChangeLabel,
  historyRemainderLabel,
  listsInline,
} from './historyLabels';

type HistoryChangeProps = {
  entry: Pick<IncidentHistoryEntryResponse, 'eventType' | 'domains' | 'domainCount' | 'detail'>;
};

function HistoryChange({ entry }: HistoryChangeProps) {
  const listId = useId();
  const [expanded, setExpanded] = useState(false);
  const { domains } = entry;

  if (domains === null) {
    return <>{historyChangeLabel(entry)}</>;
  }

  const listed = { eventType: entry.eventType, domainCount: entry.domainCount, detail: entry.detail, domains };

  if (listsInline(listed)) {
    return <>{historyChangeLabel(entry)}</>;
  }

  const remainder = historyRemainderLabel(entry);

  return (
    <>
      {historyChangeHeadLabel(entry)}{' '}
      <button
        type="button"
        className="diagnostics-history-domains-toggle"
        aria-expanded={expanded}
        aria-controls={listId}
        onClick={() => setExpanded((current) => !current)}
      >
        {domainCountLabel(listed)}
      </button>
      {expanded && (
        <div id={listId} className="diagnostics-history-domains">
          {domains.join(', ')}
          {remainder !== null && ` ${remainder}`}
        </div>
      )}
    </>
  );
}

export default HistoryChange;
